import "./Checkbox.css"

interface CheckboxProps {
    checked: boolean,
    handleChecked: () => void,
    checkedButtonImg: string,
}
export const Checkbox:React.FC<CheckboxProps> = ({checked, handleChecked, checkedButtonImg}) => {
    return (
        <div className={checked ? 'checked' : 'policies__accepting__input'} onClick={() => handleChecked()} >
            <img src={checkedButtonImg} alt="checked" />
        </div>
    )
}